import {authService} from './../services/authService';

export const loading = (isLoading) =>  {
    return({
        type:"APP_LOADING",
        isLoading:isLoading
    });
};
const setSubordinates = (subordinates) =>{
    return{
        type:"SET_SUBORDINATES",
        subordinates
    }
};
export const getSubordinates = () => {
    return async dispatch => {
        return dispatch(setSubordinates(await authService.request({
            method:"GET",
            url : "/api/PersonnelApi/GetSubordinates"
        })));
    }
}
export const getSubordinateImages = (url) => {
    return async dispatch => {
        return await authService.request({
            method:"GET",
            url:url,
            header:{
                "Content-Type": "image/png"
            }
        })
    }
}